/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDarkChartAxisBase } from "./d-theme-dark-chart-axis-base";

export class DThemeDarkChartAxisX extends DThemeDarkChartAxisBase {}
